import { render, staticRenderFns } from "./RidesPerStatus.vue?vue&type=template&id=41c20a98&scoped=true&"
import script from "./RidesPerStatus.vue?vue&type=script&lang=js&"
export * from "./RidesPerStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c20a98",
  null
  
)

export default component.exports